import { createTheme } from '@mui/material/styles'
import colors from './colors'
import publicRolePlayStyles from './publicRolePlayStyles'
import './fonts/fonts.css'
import './override.css'

const companyWebsiteTheme = createTheme({
  spacing: 2,
  palette: {
    primary: {
      main: colors.MidnightTeal400,
      contrastText: colors.GoldenYellow100
    },
    secondary: { main: colors.GoldenYellow300 },
    background: {
      paper: colors.White,
      default: colors.MetalGrey50,
      yellow: colors.GoldenYellow50
    },
    action: {
      selected: colors.MidnightTeal400,
      active: colors.MidnightTeal400,
      disabled: colors.MutedTeal100
    }
  },
  typography: {
    fontFamily: 'Poppins',
    color: colors.MidnightTeal400,
    allVariants: {
      fontFamily: 'Poppins',
      color: colors.MidnightTeal400,
      fontWeight: 'normal'
    },
    h1: {
      fontSize: 32,
      fontFamily: 'P22Mackinac',
      fontWeight: 'bold',
      lineHeight: '140%'
    },
    h2: {
      fontSize: 24,
      fontFamily: 'P22Mackinac',
      fontWeight: 'bold',
      lineHeight: '140%'
    },
    h3: {
      fontSize: 20,
      fontFamily: 'P22Mackinac',
      fontWeight: 'bold',
      lineHeight: '140%'
    },
    h4: {
      fontSize: 18,
      fontWeight: 600,
      lineHeight: '140%'
    },
    h5: {
      fontSize: 16,
      fontWeight: 600,
      lineHeight: '140%'
    },
    h6: {
      fontSize: 14,
      fontWeight: 600,
      lineHeight: '140%'
    },
    body1: {
      fontFamily: 'Poppins'
    },
    deskBody1: {
      fontFamily: 'Poppins',
      fontSize: 18,
      lineHeight: '170%',
      letterSpacing: '0.18px',
      color: colors.MidnightTeal400,
    },
    eyebrow: {
      fontSize: 13,
      fontWeight: 600,
      lineHeight: '100%',
      textTransform: 'uppercase'
    },
    eyebrow2: {
      fontSize: 12,
      fontWeight: 600,
      lineHeight: '140%',
      textTransform: 'uppercase',
      color: colors.Aluminium
    }
  },
  components: {
    MuiButton: {
      defaultProps: {
        variant: 'contained',
        color: 'secondary'
      },
      styleOverrides: {
        root: {
          borderRadius: 68,
          padding: '24px 32px',
          fontSize: 16,
          fontWeight: 'bold',
          color: colors.MidnightTeal400,
          textAlign: 'center',
          textTransform: 'none',
          boxShadow: 'none',
          '&.MuiButton-sizeSmall': {
            padding: '8px 16px',
            fontSize: 14
          },
          '&:hover': {
            boxShadow: 'none'
          },
          variants: [
            {
              props: { variant: 'contained', color: 'muted' },
              style: {
                backgroundColor: colors.Grey50,
                color: colors.MidnightTeal400,
                '&:hover': {
                  backgroundColor: colors.Grey100
                }
              }
            },
            {
              props: { variant: 'contained', color: 'secondary' },
              style: {
                '&:hover': {
                  backgroundColor: colors.GoldenYellow100
                }
              }
            },
            {
              props: { variant: 'outlined', color: 'primary' },
              style: {
                '&:hover': {
                  backgroundColor: colors.MidnightTeal400,

                  '& .MuiSvgIcon-root': {
                    color: colors.White
                  },
                  '& .MuiTypography-root': { color: colors.White },
                  '&.MuiButton-root': { color: colors.White }
                }
              }
            },
            {
              props: { variant: 'contained', color: 'primary' },
              style: {
                '&:hover': {
                  backgroundColor: colors.SecondaryUserText
                }
              }
            },
            {
              props: { variant: 'outlined' },
              style: {
                '&.Mui-disabled': { borderColor: colors.Grey300 }
              }
            },
            {
              props: { variant: 'contained', color: 'error' },
              style: {
                backgroundColor: colors.ErrorRed50,
                color: colors.MidnightTeal400,
                '&:hover': {
                  backgroundColor: colors.GoldenYellow100
                }
              }
            },
          ]
        },
      }
    },
    MuiSelect: {
      styleOverrides: {
        root: {
          fontWeight: 500,
          fontSize: 15,
          color: colors.Grey400,
          borderRadius: 100
        }
      }
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          fontSize: 16,
          color: colors.Grey400
        }
      }
    },
    MuiStack: {
      defaultProps: {
        padding: 0
      }
    },
    MuiDialog: {
      defaultProps: {
        PaperProps: {
          sx: { borderRadius: '16px', padding: '24px' }
        }
      }
    }
  },
  publicRolePlay: publicRolePlayStyles
})

export default companyWebsiteTheme
